<template>
	<div class="columns-mapping-step">
		<div class="mapping-title">Map to predefined properties</div>
		<div class="horizontal-divider mt-1 mb-2" />
		<div class="font-size-sm mb-2">Note: Columns can be merged before being mapped</div>
		<div class="columns-mapping-step-content display-flex">
			<div class="flex-3">
				<div class="header-display display-flex mb-2">
					<div class="flex-1">Input headers</div>
					<div class="flex-1 ml-10">Map to</div>
				</div>
				<ColumnsMapper
					class="columns-mapper-container scroll-on-overflow"
					:newHeaderRow="state.newHeaderRow"
					:columnsMapping="state.columnsMapping"
					:columnOptions="columnOptions"
					:rows="rows"
					@updateState="updateState"
					@setMappingEditorHoveredColumn="setMappingEditorHoveredColumn"
				/>
			</div>

			<PreviewBox title="Column preview" class="preview-box-container scroll-on-overflow flex-4">
				<div class="anim-opacity" :class="{ 'anim-show': columnPreview.length > 0 }">
					<div v-for="(row, index) in columnPreview" :key="index" class="text-overflow-ellipsis mx-1 my-2">
						{{ row || ' ' }}
					</div>
				</div>
			</PreviewBox>
		</div>
	</div>
</template>

<script>
import PreviewBox from '@/components/common/PreviewBox';

import ColumnMapperService from '../ColumnMapperService';

export default {
	name: 'ColumnsMappingStep',
	components: {
		PreviewBox,
		ColumnsMapper: () => import('../ColumnsMapper'),
	},
	props: {
		state: { type: Object },
		rows: { type: Array },
		columnOptions: { type: Array },
	},
	computed: {
		isStepComplete() {
			return ColumnMapperService.hasMoreThanOneMapping(this.state.columnsMapping);
		},
	},
	methods: {
		updateState(newColumnsMapping) {
			this.$emit('updateState', { columnsMapping: newColumnsMapping });
		},
		setMappingEditorHoveredColumn(columnNames) {
			const columnPreviewLength = Math.min(6, Object.keys(this.state.newHeaderRow).length); // This is to prevent UI from "jumping"
			this.columnPreview = ColumnMapperService.getColumnPreviewSample(this.rows.slice(0, columnPreviewLength), columnNames);
		},
	},
	data() {
		return { columnPreview: [] };
	},
};
</script>

<style scoped lang="scss">
.columns-mapping-step {
	$top-section-height: 80px;
	$column-editor-top-section-height: 42px;

	color: var(--primary-font-color);

	.mapping-title {
		font-size: 16px;
		font-weight: 600;
	}
	.columns-mapping-step-content {
		max-height: calc(100% - #{$top-section-height});
	}
	.header-display {
		padding: 4px 8px;
		border-radius: 7px;
		background-color: #f8f9fb;
		font-size: 12px;
		font-weight: 400;
	}
	.columns-mapper-container {
		max-height: calc(100% - #{$column-editor-top-section-height});
	}
	.preview-box-container {
		max-height: calc(100% - #{$top-section-height});
		flex-basis: 40%;
	}

	@media (max-width: $device-sm) {
		.preview-box-container {
			display: none;
		}
		::v-deep {
			.columns-mapper {
				.eye-svg {
					display: inline;
				}
			}
		}
	}
}
</style>
